// Auth utility functions

export const getStoredUser = () => {
  try {
    const user = localStorage.getItem('user');
    return user ? JSON.parse(user) : null;
  } catch (_e) {
    return null;
  }
};

export const setStoredUser = (user) => {
  localStorage.setItem('user', JSON.stringify(user));
};

export const clearStoredUser = () => {
  localStorage.removeItem('user');
  localStorage.removeItem('token');
};

export const getStoredToken = () => {
  return localStorage.getItem('token');
};

export const setStoredToken = (token) => {
  localStorage.setItem('token', token);
};

export const isAuthenticated = () => {
  return !!getStoredUser() && !!getStoredToken();
};

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export const initiateGoogleLogin = (role = 'toc', planId = null, cycle = null) => {
  // Store the role for after OAuth callback
  localStorage.setItem('pending_role', role);
  // Store a plan chosen on the public pricing page (if any) so it survives the
  // OAuth redirect — same mechanism as pending_role, since query params are lost.
  if (planId) {
    localStorage.setItem('pending_plan', planId);
  } else {
    localStorage.removeItem('pending_plan');
  }
  // Annual billing choice ('annual' only; monthly is the default everywhere).
  if (cycle === 'annual') {
    localStorage.setItem('pending_cycle', 'annual');
  } else {
    localStorage.removeItem('pending_cycle');
  }
  const redirectUrl = window.location.origin + '/auth/callback';
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
};

// Read (and clear) a plan stashed by initiateGoogleLogin. Returns null when
// absent. Validated by the caller against the known plan id set.
export const getPendingPlan = () => {
  const plan = localStorage.getItem('pending_plan');
  localStorage.removeItem('pending_plan');
  return plan;
};

// Read (and clear) the annual billing-cycle flag stashed by initiateGoogleLogin.
// Returns 'annual' or null.
export const getPendingCycle = () => {
  const cycle = localStorage.getItem('pending_cycle');
  localStorage.removeItem('pending_cycle');
  return cycle === 'annual' ? 'annual' : null;
};
